<template>
  <div>
      <van-nav-bar title="抽奖记录" left-text="" left-arrow @click-left="onClickLeft()" />
      <div class="tips">
      *说明：<br/>
      不锈钢咖啡壶、电热水瓶、电饭煲、按摩足浴桶和微压深炖锅等奖品半个月快递一次；<br/>
      保温杯、冲锋衣、热熔机将在9月1日之后每周五进行快递发放。<br/>
      请及时填写收货地址，填写完成后请耐心等待发货！如有需要加急可联系所维护的业务人员。
    </div> 
      <div class="table_detail" style="margin-top:10px;">
      <table>
        <thead>
          <tr>
            <th>序号</th>
            <th>奖品名称</th>
            <th>尺码/颜色</th>
            <th>是否核销</th>
            <th>兑奖码</th>
            <th>抽奖时间</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item,idx) in drawList" v-bind:key="idx">
            <td>{{ idx+1 }}</td>
            <td>{{ item.PrizeName }}</td>
            <td>{{ item.Size }}</td>
            <td>{{ item.IsGrant==1?'是':'否' }}</td>
            <td>{{ item.WinningCode }}</td>
            <td>{{ item._CreateTime }}</td>
          </tr>
        </tbody>
      </table>
    </div>      
    <van-pagination
      mode="simple"
      v-model="currentPage"            
      :page-count="pageCount"
      :show-page-size="3"
      force-ellipses
      style="margin-top:10px;" @change="handleCurrentChange" />    
    </div>    
</template>

<script>
import { NavBar } from "vant";
import { Pagination } from 'vant';

export default {
  name: "LuckDrawRecord",
  data() {
    return {      
      currentPage: 1,
      drawList: [],
      loading: false, 		// 是否处在加载状态
      finished: false, 		// 是否已加载完成
      total: 0,				    // 数据总条数
      pageCount: 0,       // 总页数
      pageSize: 0,    // 每页条数
    };
  },
  props: {},
  computed:{
    isLogined(){return this.$store.state.isLogin}
  },
  methods: {
    ShowLogin(){
      this.$store.commit("showLogin");
    },
    
    GetData(){
      var that=this;
      if(that.isLogined){     
        that.$http.get("SDWorker/GetLuckyDrawRecord2024", {
          params: {
            period: 2,
            pageindex: that.currentPage,
            sort: '_CreateTime DESC',
          }
        }).then(res=>{
          for (let i = 0; i < res.data.ListData.length; i++) 
          {
            var record = res.data.ListData[i];
            if(record.IsGrant==1){
              record.IsGrantDesc="是";
            }else{
              record.IsGrantDesc="否";
            }
            switch (record.WinningNum) {
              case 1:
                record.PrizeName = "28.8元红包";
                break;
              case 2:
                record.PrizeName = record.Prize;
                break;
              case 3:
                record.PrizeName = record.Prize;
                break;
              case 4:
                record.PrizeName = record.Prize;
                break;
              case 5:
                record.PrizeName = record.Prize;
                break;
              case 6:
                record.PrizeName = "2024元红包";
                break;
              default:
                break;
            }
          }
          that.drawList=res.data.ListData;
          that.total = res.data.TotalCount;		// 给数据条数赋值
          that.loading = true;			// 加载状态结束 
          that.pageCount = res.data.PageCount;
          that.pageSize = res.data.PageSize;
          // 如果list长度大于等于总数据条数,数据全部加载完成
          if (that.drawList.length >= res.data.TotalCount) {
            that.finished = true;		// 结束加载状态
          }
        });
      }
    },
    handleCurrentChange (page) {
      this.currentPage = page;
      this.GetData();
    },
    /*返回 */
    onClickLeft() {
      this.$router.back(-1);
    },
  },
  created() {
    this.GetData();
  },
  components: {
    [Pagination.name]:Pagination,
    [NavBar.name]:NavBar,
  },
};
</script>

<style scoped>
  .table_detail{
    overflow:auto;
    width: 100%;
    /* 固定滚动高度 */
    max-height: calc(100vh - 220px);
    border-top: 1px solid #EBEBEB;
    border-bottom: 1px solid #EBEBEB;
    border-right: 0;
    
  }
  table {
    border-collapse: collapse;
    table-layout: fixed;
    width: 100%;
  }
  td, th {
    border-right: 1px solid #EBEBEB;
    border-bottom :1px solid #EBEBEB;
    width:100px;
    height: 35px;
    color: #333;
    box-sizing: border-box;
    background-color: #ffffff;
    font-size: 12px;
    text-align: center;
    padding: 5px 5px 5px 0;
  }
  th {
    background: #FAFAFA;
    color: #999;
    font-weight: normal;
  }
  /* 固定首列*/
  td:first-child,
  th:first-child {
    width:100px;
    position:sticky;
    left:0;
    z-index:1;
    padding-left: 5px;
  }
  /* 固定表头*/
  thead tr th {
    position:sticky;
    top:0;
  }
  th:first-child{
    z-index:2;
  }
  /* 固定表头*/
  tfoot tr th {
    position:sticky;
    bottom:0;
    color: #333;
    font-weight: bold;
    border-bottom: 0;
  }
  th:first-child{
    z-index:2;
  }


  .tips {
    font-size: 15px;
    color: red;
    margin-left: 10px;
    margin-right: 10px;
    margin-top: 5px;
  }

</style>
